import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";
function Newsletter_44() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter May 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            Switzerland Proposes New Corporate Sustainability Governance
            Framework.
          </title>
          <meta
            name="description"
            content="Switzerland has opened consultation on a proposed Sustainable Corporate Governance Act, marking a significant step toward aligning national ESG rules with evolving European sustainability frameworks."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          Switzerland Proposes New Corporate Sustainability Governance
          Framework.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/May_2026_1.webp")}
            alt="Switzerland Proposes New Corporate Sustainability Governance Framework."
            loading="lazy"
          />
        </figure>
        <p>
          Switzerland has opened consultation on a proposed Sustainable
          Corporate Governance Act, marking a significant step toward aligning
          national ESG rules with evolving European sustainability frameworks.
          The draft law would consolidate existing reporting duties into a
          dedicated framework and introduce clearer expectations on
          sustainability disclosure, human rights due diligence and
          environmental risk management.
        </p>
        <p>
          Under the proposal, sustainability reporting would apply to companies
          with at least 1,000 employees and global net turnover above CHF 450
          million. This is expected to cover about 100 companies, compared with
          roughly 200 under current Swiss non-financial reporting rules. Reports
          would need to follow European Sustainability Reporting Standards or an
          equivalent recognised framework, strengthening comparability for
          investors, regulators and business partners.
        </p>
        <p>
          The initiative also introduces risk-based due diligence obligations
          for larger companies with more than 5,000 employees and CHF 1.5
          billion in turnover. These companies would assess actual and potential
          impacts across operations and supply chains, supported by governance
          measures, prevention plans, remediation processes, grievance channels
          and ongoing monitoring. Switzerland’s ESG framework has developed
          steadily since 2021 and 2022, when rules on non-financial reporting,
          conflict minerals and child labour risks were introduced.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Switzerland’s proposed framework signals a move toward more
            structured sustainability governance, with reporting, due diligence
            and supply-chain accountability becoming board-level disciplines
            rather than compliance exercises. Companies can prepare by mapping
            ESG data ownership, testing supplier-risk visibility, aligning
            disclosures with recognised standards, and embedding grievance,
            remediation and monitoring processes early. The advantage will lie
            in building systems that are auditable, comparable and
            decision-useful before legal thresholds formally apply.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          ISSB Enhances Global Sustainability Reporting Through Practical
          Nature-Related Disclosure Guidance.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/May_2026_2.webp")}
              alt="ISSB Enhances Global Sustainability Reporting Through Practical Nature-Related Disclosure Guidance."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          The global sustainability reporting landscape is moving toward a more
          structured treatment of nature-related financial information. The ISSB
          staff has recommended developing a non-mandatory IFRS Practice
          Statement, rather than a separate nature standard, to help companies
          apply IFRS S1 while addressing material dependencies, impacts, risks
          and opportunities linked to biodiversity, water, land use and natural
          resources.
        </p>
        <p>
          The initiative builds on the IFRS Foundation’s 2023 launch of IFRS S1
          and IFRS S2, which created a global baseline for sustainability and
          climate disclosures. Nature is gaining similar attention as an
          enterprise-value issue, with $44 trillion of economic value
          generation, over half of global GDP, estimated to be moderately or
          highly dependent on nature. Market readiness is also rising, with 733
          organisations across 56 jurisdictions committing to TNFD-aligned
          reporting by 2026.
        </p>
        <p>
          The proposed Practice Statement is expected to guide companies on
          identifying nature-related risks across operations, supply chains and
          financed activities, including exposure to water stress, land
          degradation, ecosystem loss, deforestation and resource scarcity. It
          may also help organisations explain how these factors influence
          business models, capital allocation, asset values, procurement
          decisions and long-term resilience. By using the existing IFRS S1
          architecture, the guidance can support more consistent disclosure of
          governance processes, risk management practices, location-specific
          data, sector exposure, transition plans, metrics and targets without
          creating an additional mandatory reporting layer.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            For industries and companies, this initiative can improve how
            nature-related risks are identified, measured and reported across
            operations and supply chains. Sectors dependent on land, water,
            forests, agriculture, mining, real estate and finance may face
            greater expectations to disclose exposure to ecosystem loss,
            resource scarcity and biodiversity risks. Companies can use the
            guidance to strengthen risk management, investor communication,
            capital planning and long-term business resilience.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Germany Advances Industrial Decarbonisation with €5 Billion Funding
          Round.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/May_2026_3.webp")}
            alt="Germany Advances Industrial Decarbonisation with €5 Billion Funding Round."
            loading="lazy"
          />
        </figure>
        <p>
          Germany has opened a €5 billion ($5.85 billion) funding round to
          accelerate emissions reduction in heavy industry, targeting steel,
          cement, chemicals, glass and other energy-intensive sectors. The
          programme uses 15-year carbon contracts for difference, compensating
          companies for the cost gap between conventional production and
          lower-carbon alternatives.
        </p>
        <p>
          The revised auction framework gives industrial sites four years to
          achieve a 50% emissions reduction and aims for an 85% reduction by the
          final contract year. It also expands eligibility to carbon capture and
          storage, industrial heat projects and facilities covered by the EU
          Emissions Trading System, with bids assessed competitively on the
          subsidy required per tonne of CO2 avoided.
        </p>
        <p>
          The initiative builds on Germany’s wider climate pathway, under which
          national greenhouse gas emissions fell from 1,252 million tonnes of
          CO2 equivalent in 1990 to 649 million tonnes in 2024, a 48% reduction.
          Industry remains material to the transition, accounting for about
          one-fifth of national emissions, including 153 million tonnes of CO2
          equivalent in 2024.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The funding round can reshape capital allocation across heavy
            industry by making low-carbon production commercially bankable
            rather than purely compliance-led. Steel, cement, chemicals and
            glass producers may accelerate investments in electrification,
            hydrogen, carbon capture and industrial heat solutions. The 15-year
            contract structure provides revenue visibility, reduces transition
            risk and strengthens long-term competitiveness, while competitive
            bidding pushes companies to prove measurable emissions cuts with
            disciplined project economics.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          EBA Proposes Simplified ESG Supervisory Reporting Requirements for
          Banks.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/May_2026_4.webp")}
            alt="EBA Proposes Simplified ESG Supervisory Reporting Requirements for Banks."
            loading="lazy"
          />
        </figure>
        <p>
          The European Banking Authority has proposed a major simplification of
          ESG supervisory reporting for banks, aiming to reduce compliance
          complexity while preserving essential climate and sustainability risk
          information for supervisors. The consultation is open until 10 July
          2026, with the revised framework expected to apply from September
          2027. The proposal reflects the wider European focus on making
          sustainable finance rules more practical, consistent and proportionate
          for financial institutions.
        </p>
        <p>
          The framework introduces three reporting levels based on size,
          business model and risk profile. Large banks, including institutions
          with more than €30 billion in assets, would continue to provide
          detailed ESG data, broadly aligned with Pillar 3 disclosure
          requirements. Smaller and non-complex institutions would follow a
          simplified annual template focused on key physical and transition risk
          indicators. The proposal also removes selected EU Taxonomy templates
          from supervisory reporting, helping reduce duplication where similar
          information is already disclosed through other regulatory channels.
        </p>
        <p>
          The initiative builds on earlier ESG reporting developments in the EU
          banking sector, including climate risk disclosures introduced under
          Pillar 3 and expanded sustainability obligations under the 2024 EU
          Banking Package. It also supports the EU’s broader simplification
          agenda across CSRD, CSDDD, Taxonomy and CBAM requirements, while
          maintaining supervisory visibility over banks’ exposure to
          climate-related risks, financed emissions and transition-sensitive
          sectors.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            This proposed simplification can help banks move from
            compliance-heavy reporting to more risk-focused ESG supervision. By
            aligning supervisory templates with existing Pillar 3 disclosures
            and reducing duplication, banks can improve data consistency, lower
            internal reporting burdens and allocate more resources to climate
            risk assessment, portfolio analysis and transition planning. For
            smaller institutions, proportionate templates can support gradual
            ESG data maturity without compromising regulatory oversight.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          UK FCA Introduces Pilot Framework for ESG Rating Providers
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/May_2026_5.webp")}
            alt="UK FCA Introduces Pilot Framework for ESG Rating Providers"
            loading="lazy"
          />
        </figure>

        <p>
          The UK Financial Conduct Authority has invited ESG ratings providers
          to join a voluntary reporting pilot to shape future supervision of the
          sector. The exercise will test whether proposed metrics are clear,
          feasible, proportionate across different business models and useful
          for supervisory purposes. Providers can express interest by 13 May
          2026, ahead of a planned regulatory regime starting on 29 June 2028.
        </p>
        <p>
          The proposal focuses on how ESG ratings are produced, governed and
          communicated. Providers would be expected to report information on
          rating objectives, ESG factors assessed, data inputs, methodology
          changes, scoring scales, coverage policies, review processes,
          governance controls and quality assurance. The framework also gives
          attention to conflict management where firms provide ratings alongside
          other sustainability-related services.
        </p>
        <p>
          The pilot is intended to simulate practical reporting before mandatory
          obligations apply, allowing firms to assess internal systems, data
          availability and submission processes. Market estimates suggest that
          75 to 150 ESG ratings providers may fall within the UK framework,
          while about 30 providers have already adopted the voluntary industry
          code, giving the regulator a reference point for proportional
          reporting design
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            ESG rating providers can use the UK FCA’s pilot as a practical
            readiness exercise before formal rules apply. The key takeaway is
            the need for stronger governance around methodologies, data sources,
            scoring logic, review cycles and conflict management. This can help
            the industry build greater credibility, reduce interpretation gaps,
            improve client confidence and align rating practices with rising
            expectations from investors, companies and regulators.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_44;
